export default __webpack_public_path__ + "static/media/delivery.896dffb0.svg";